function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:transparent;}.cls-2{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 50,
  cy: 50,
  r: 50
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M75,35.79a3.27,3.27,0,0,0-3.1-2.21H28.29a3.26,3.26,0,0,0-3.09,2.21A3.37,3.37,0,0,0,25,36.85v26.3a3.12,3.12,0,0,0,.11.82,3.26,3.26,0,0,0,3.16,2.45H71.86A3.28,3.28,0,0,0,75,64a3.12,3.12,0,0,0,.1-.82V36.85A3.36,3.36,0,0,0,75,35.79Zm-3.6-.07-21.28,15-21.28-15ZM27.16,62.53V37.18l18,12.68Zm1.23,1.75L47,51.17l3.12,2.2,3.12-2.2L71.76,64.28ZM73,62.53,55.05,49.86,73,37.18Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M20.59,39.23H5a1.07,1.07,0,1,0,0,2.14H20.59a1.07,1.07,0,1,0,0-2.14Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M20.59,45.34h-11a1.07,1.07,0,0,0,0,2.14h11a1.07,1.07,0,1,0,0-2.14Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M20.59,51.45H14.18a1.07,1.07,0,0,0,0,2.14h6.41a1.07,1.07,0,0,0,0-2.14Z"
});

var SvgFooterFeedback = function SvgFooterFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFooterFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/footer-feedback.614cee28.svg";
export { ForwardRef as ReactComponent };